<div class="bolt-container">
  @for (report of reportDetails; track report.driverName) {
    <div class="bolt-background-ultralightGray report-container">
      <div
        class="bolt-row bolt-justify-content-between bolt-space-inner-wide-xl"
        >
        <div class="bolt-col-10 reports-details">
          <img
            class="product-image"
            src="assets/images/icons/person-circle-colorized.svg"
            />{{ report.driverName }}
          </div>
          <div class="bolt-col-2">
            @if (report.status === 'Clean') {
              <div class="reports-icon">
                <bolt-icon
                  name="checkmark-circle-filled"
                  color="theme-success"
                  ></bolt-icon
                  >&nbsp;&nbsp;Clear
                </div>
              }
              @if (report.status !== 'Clean') {
                <div class="reports-icon">
                  <bolt-icon
                    name="exclamation-triangle-filled"
                    color="theme-warning"
                    ></bolt-icon
                    >&nbsp;&nbsp;Adverse
                  </div>
                }
              </div>
            </div>
            @for (claim of report.claims; track claim.claimDate) {
              @for (coverage of claim.claimCoverages; track coverage.amountPaid; let last = $last) {
                <div class="bolt-row alh-item bolt-background-white">
                  <div class="bolt-col-xs-6 bolt-col-lg-3"><strong>Claim type</strong></div>
                  <div class="bolt-col-xs-6 bolt-col-lg-9">{{ coverage.claimType }}</div>
                  <div class="bolt-col-xs-6 bolt-col-lg-3"><strong>Claim status</strong></div>
                  <div class="bolt-col-xs-6 bolt-col-lg-9">{{ coverage.status }}</div>
                  <div class="bolt-col-xs-6 bolt-col-lg-3"><strong>Amount paid</strong></div>
                  <div class="bolt-col-xs-6 bolt-col-lg-9">{{ coverage.amountPaid | currency }}</div>
                  <div class="bolt-col-xs-6 bolt-col-lg-3"><strong>Claim date</strong></div>
                  <div class="bolt-col-xs-6 bolt-col-lg-9">{{ claim.claimDate }}</div>
                </div>
              }
            }
          </div>
        }
      </div>
